module.exports = __webpack_public_path__ + "media/images/athletes/1753-79546c00e50ebbedb092c44771104b8a.png";